module.exports = __webpack_public_path__ + "img/yahoo.7b913811.svg";